var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNitexLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Black",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 484.4 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106.3,0h34v100h-41.5l-24-53.3h-1.3v53.3h-34V0h41.5l24,53.3h1.3V0ZM149.6,100V0h40v100h-40ZM285.6,0v31.2h-24v68.8h-40V31.2h-24V0h88ZM377.6,0v28.4h-44v8.9h40v25.3h-40v8.9h44v28.4h-84V0h84Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.5,100c-6.9,0-12.5-5.6-12.5-12.5s5.6-12.5,12.5-12.5,12.5,5.6,12.5,12.5-5.6,12.5-12.5,12.5ZM12.5,76.4c-6.1,0-11.1,5-11.1,11.1s5,11.1,11.1,11.1,11.1-5,11.1-11.1-5-11.1-11.1-11.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9,81.9h6.3c2.1,0,3.5,1.3,3.5,3.1s-1,2.9-2.5,3.1h0c1.4.2,1.7.9,1.9,1.8l1.2,3.5h-2.7l-1-3c-.3-.8-.7-1.2-1.9-1.2h-2.1v4.2h-2.7v-11.6ZM14.9,85.5c0-1-.6-1.6-2-1.6h-2.4v3.3h2.4c1.4,0,2-.6,2-1.6Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M428,0l5.7,34.8h1.3l5.6-34.8h43.7l-18,49.7v.8l18,49.5h-43.7l-5.6-35.1h-1.3l-5.7,35.1h-43.7l18-49.5v-.8L384.3,0h43.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNitexLogo);
export default __webpack_public_path__ + "static/media/nitexLogo.ebcf8557c79ea7664aa182051ea4ac20.svg";
export { ForwardRef as ReactComponent };